import AreYouSureModal from "components/modals/AreYouSureModal";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import { WebformActivityPanel } from "webform/activity/WebformActivityPanel";
import { WebformArtistDetailSection } from "webform/WebformArtistDetailSection";
import { WebformDetailSection } from "webform/WebformDetailSection";
import { WebformPromoterDetailSection } from "webform/WebformPromoterDetailSection";
import { WebformVenueDetailSection } from "webform/WebformVenueDetailSection";
import { LinkedArtistsWebformPanel } from "../../components/linkedArtists/LinkedArtistsWebform";
import FreeFieldsInWebformPanel from "webform/FreeFieldsInWebformPanel";

export const WebformDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.WebformDetailFrontModel>();
  const [displayDeleteModal, setDisplayDeleteModal] = React.useState(false);

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <SectionPanel.Section>
        <WebformDetailSection webform={viewModel.webform} />

        <LinkedArtistsWebformPanel
          webformId={viewModel.webform.webformId}
          formUrl={viewModel.webform.formUrl}
        />

        <WebformArtistDetailSection
          webformId={viewModel.webform.webformId}
          artist={viewModel.webform.artist}
        />

        <WebformPromoterDetailSection
          webformId={viewModel.webform.webformId}
          promoter={viewModel.webform.promoter}
        />

        <WebformVenueDetailSection
          webformId={viewModel.webform.webformId}
          venue={viewModel.webform.venue}
        />

        <FreeFieldsInWebformPanel
          webform={viewModel.webform}
          freeFields={viewModel.freeFields || []}
        />

      </SectionPanel.Section>
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <GeneralOptionsPanel
        data={viewModel.optionsPanel}
        links={[
          { text: RESX.Buttons.ListView, visible: true, href: viewModel.listUrl },
          { text: RESX.Buttons.btnDelete, visible: true, onClick: () => { setDisplayDeleteModal(true); } },
        ]}
      />

      <WebformActivityPanel
        webformId={viewModel.webform.webformId}
        config={viewModel.activityPanel}
      />

      {displayDeleteModal && <AreYouSureModal
        title={RESX.GeneralLabels.Delete}
        textContent={RESX.GeneralWarnings.DeleteSure}
        onClose={() => { setDisplayDeleteModal(false); }}
        onYes={async () => window.CoreApi.WebformConfiguration.Delete({ webformId: viewModel.webform.webformId }).then(() => window.location.href = viewModel.listUrl)}
        yesButtonLabel={RESX.GeneralLabels.Delete}
        yesButtonColor="red"
      />}
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}